/**
 * Guía: Bonos de regalo.
 *
 * Contenido derivado del capítulo **32** del manual: §0 (esta pantalla no
 * otorga nada, rinde cuentas) y §1 (quién entra y qué lleva la exportación).
 *
 * La guía es corta a propósito, como la pantalla: no hay ninguna operación
 * de escritura. Lo único que hay que saber es qué mide cada cifra y que la
 * exportación lleva datos personales.
 */

import type { TourFlow } from '../types';

// Regalos › Bonos en dinero (antes /promo-credits). Es la guía de la entrada
// «Regalos» del menú (`/gifts` abre en Bonos › Resumen); las de campañas de
// bono y de puntos cuelgan de subrutas y ganan por ser más específicas.
const CREDITOS_PATH = '/gifts';
const RESUMEN_PATH = '/gifts/bonos/resumen';
const OTORGAR_PATH = '/gifts/bonos/otorgar';

export const c32CreditosPromocionales: TourFlow = {
  id: 'admin.promo-credits',
  chapter: '32',
  title: 'Bonos de regalo',
  summary:
    'El libro de lo que se regaló: qué mide cada cifra y qué lleva la exportación.',
  href: CREDITOS_PATH,
  requiresCountry: true,
  estimatedMin: 2,
  steps: [
    {
      id: 'intro',
      title: 'Bonos de regalo: dinero que pone 121Pass',
      body:
        'Un bono es saldo en dinero que 121Pass regala: llega por una campaña o a mano ' +
        'desde «Otorgar». Aquí se mira qué pasó con él. No se puede revocar ni ajustar ' +
        'un bono ya otorgado, y es a propósito.',
      route: RESUMEN_PATH,
    },
    {
      id: 'kpis',
      title: 'Acreditado no es gastado',
      body:
        'Una cosa es cuánto se repartió y otra cuánto han usado los clientes. La diferencia ' +
        'es saldo vivo en billeteras: dinero comprometido que todavía no ha salido. ' +
        'Confundirlas cambia por completo la lectura del coste de una campaña.',
      target: 'admin.promoCredits.kpis',
      route: RESUMEN_PATH,
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'export-has-personal-data',
      title: 'La exportación lleva datos personales',
      body:
        'Nombre, correo y teléfono de cada beneficiario. Es lo que hace falta para ' +
        'contrastar una campaña, y es también lo que obliga a tratar ese archivo como lo ' +
        'que es. Se exporta lo filtrado, no todo el país.',
    },
    {
      id: 'grant-credit',
      title: 'Regalar bono a mano',
      body:
        'En «Otorgar» eliges clientes o pegas una lista, pones el monto y el motivo, y ' +
        'revisas la vista previa. El bono llega al saldo de la billetera y paga pedidos ' +
        'completos. Por encima del tope del país, solo un super administrador puede ' +
        'confirmarlo, con el código del correo y el del autenticador.',
      target: 'admin.gifts.tabs',
      route: OTORGAR_PATH,
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'country-scope',
      title: 'Tu país, y sólo tu país',
      body:
        'Tanto la pantalla como la exportación se resuelven contra el país de tu ficha. Si ' +
        'una campaña que conoces no aparece aquí, comprueba en qué país se creó.',
    },
  ],
};
